import React, { Component } from 'react';

import './breadcrumb.css'
import { NavLink } from 'react-router-dom';
import { MdKeyboardArrowRight } from "react-icons/md";


interface BreadcrumbProps {
  children: JSX.Element[]
}


export default class Breadcrumb extends Component<BreadcrumbProps> {
  render() {
    const itens = []

    for (const item of this.props.children) {
      itens.push(item)
    }

    return <aside id="breadcrumb" aria-label="Breadcrumb">
      <span className="sr-only">Você está em:</span>
        <ol>
          {itens}
        </ol>
    </aside>
  }
}


interface BreadcrumbItemProps {
  href?: string
}

export class BreadcrumbItem extends Component<BreadcrumbItemProps> {
  render() {
    const href = this.props.href

    if (href)
      return <li><NavLink to={href}>{this.props.children}</NavLink><MdKeyboardArrowRight aria-hidden={true} /></li>
    else
      return <li aria-current="page">{this.props.children}</li>
  }
}
